

<div  class="modal fade " id="splashModal" data-backdrop="static" tabindex="-1" aria-labelledby="splashModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable" role="document">

    <div class="modal-content">
      <div class="modal-header p-2">
         <h5 class="modal-title text-dark-emphasis fs-3" id="splashModalLabel">{{ splashs[selectedSlashIndex]?.title }}</h5>
        <div class="d-flex justify-content-end">
          <!--begin::Close-->
          <div
            class="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary"
            data-bs-toggle="tooltip"
            data-bs-dismiss="click"
            aiar-label="Hide Event"
            data-bs-original-title="Hide Event"
            data-kt-initialized="1"

          >
            <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
            <span class="svg-icon svg-icon-1" (click)="closeModal()"
            ><svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
            <rect
              opacity="0.5"
              x="6"
              y="17.3137"
              width="16"
              height="2"
              rx="1"
              transform="rotate(-45 6 17.3137)"
              fill="currentColor"
            ></rect>
            <rect
              x="7.41422"
              y="6"
              width="16"
              height="2"
              rx="1"
              transform="rotate(45 7.41422 6)"
              fill="currentColor"
            ></rect>
          </svg>
        </span>
            <!--end::Svg Icon-->
          </div>
          <!--end::Close-->
        </div>
      </div>
      <div class="modal-body">
         <span class="d-flex " [innerHTML]="santizeHTML(splashs[selectedSlashIndex]?.body)"></span>
      </div>
      <div class="modal-footer p-0">
        <button *ngIf="splashs.length>0" type="button" class="btn btn-sm  btn-light-danger top-0 start-0 my-5 mr-auto" data-dismiss="modal" (click)="rm(splashs[selectedSlashIndex])" translate>Fermer</button>
        <button  class="btn btn-sm btn-icon btn-light-primary top-0 start-0 my-5" [disabled]="selectedSlashIndex === 0" (click)="back()" translate>
       <span
         [inlineSVG]="'./assets/media/icons/duotune/arrows/arr022.svg'"
         class="svg-icon svg-icon-2 svg-icon-lg-1 me-0"
       ></span>
        </button>
        <span>{{selectedSlashIndex + 1}}/{{ splashs.length }}</span>
        <button  class="btn btn-sm btn-icon btn-light-primary top-0 start-0 my-5" [disabled]="selectedSlashIndex === splashs.length - 1" (click)="next()" translate>
           <span
             [inlineSVG]="'./assets/media/icons/duotune/arrows/arr023.svg'"
             class="svg-icon svg-icon-2 svg-icon-lg-1 me-0"
           ></span>
        </button>
      </div>
    </div>
  </div>
  </div>

